import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  modalWrapper: {
    '&&': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',

      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: SPACES.xxxxl,

      minHeight: 300,

      padding: SPACES.xxl,

      outline: 'none',

      [theme.breakpoints.down('tablet')]: {
        minWidth: 320,
      },
      [theme.breakpoints.up('tablet')]: {
        minWidth: 400,
      },
    },
  },
  imageWrapperProduct: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeButton: {
    '&&': {
      borderRadius: '50%',
      position: 'absolute',

      [theme.breakpoints.down('tablet')]: {
        top: 0,
        right: 0,
      },
      [theme.breakpoints.up('tablet')]: {
        top: 4,
        right: 4,
      },
    },
  },
  addBtn: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    gap: SPACES.xs,
    minWidth: 200,
    alignItems: 'center',

    [theme.breakpoints.down('tablet')]: {
      flexWrap: 'wrap',
      minWidth: 110,
      width: '100%',
      justifyContent: 'center',
    },

    // marginLeft: '135px',
    marginTop: 40,
    marginBottom: 20,
  },

  selectionWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: '4px',
    maxWidth: 98,
    paddingLeft: 8,
    marginLeft: 'auto',
    marginRight: 'auto',
    justifyContent: 'center',
  },
}))
